export default __webpack_public_path__ + "resources/icons/d131-e9ea.png";